/**
 * @file DeliveryChangeConfirmDialog.tsx
 * @description Подтверждение правки уже согласованных условий доставки
 * (phase19.24 шаг 5.2, §4 «Диалог смены после подтверждения»).
 *
 * Решение пользователя 2026-09-21: ЛЮБОЕ изменение условий — включая смену
 * ПВЗ в том же городе — уходит клиенту новым письмом. Менеджер обязан узнать
 * это ДО правки: иначе он «просто поправит ПВЗ», а прежняя ссылка у клиента
 * умрёт без предупреждения.
 */

import { Button } from "../../ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";

interface Props {
  open: boolean;
  /** Условия выбрал клиент на витрине — формулировка мягче: письма ещё не было. */
  fromSite: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeliveryChangeConfirmDialog({
  open,
  fromSite,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Изменить условия доставки?</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2 text-sm">
          <p>
            {fromSite
              ? "Клиент выбрал эти условия сам. Новое предложение придётся согласовать: клиенту уйдёт письмо, и заказ будет ждать его ответа."
              : "Новое предложение отзовёт прежнее: старая ссылка перестанет работать, клиенту уйдёт новое письмо, заказ будет ждать ответа."}
          </p>
          <p className="text-on-surface-variant">
            Это касается любого изменения — способа, адреса, пункта выдачи или
            суммы.
          </p>
        </div>
        <DialogFooter>
          <Button variant="ghost" className="min-h-12" onClick={onClose}>
            Оставить как есть
          </Button>
          <Button className="min-h-12" onClick={onConfirm}>
            Изменить условия
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
